import type { Ref, UnwrapRef } from 'vue';

export enum AnimationDurationType {
    SHORT = 1000,
    MEDIUM = 2000,
    LONG = 3000,
}
export const ANIMATION_DURATION = AnimationDurationType.LONG;

const useAlertToast = (): {
    alertSettings: Ref<UnwrapRef<IAlert>>;
    hideAlert: () => void;
    showAlert: (
        message?: string[] | string,
        type?: AlertType,
        duration?: AnimationDurationType
    ) => void;
} => {
    const alertSettings = ref<IAlert>({
        isVisible: false,
        messages: null,
        type: 'error',
        duration: ANIMATION_DURATION,
    });

    const showAlert = (
        message?: string[] | string,
        type?: AlertType,
        duration?: AnimationDurationType
    ): void => {
        alertSettings.value.messages = message ?? null;
        alertSettings.value.type = type ?? 'error';
        alertSettings.value.isVisible = true;
        alertSettings.value.duration = duration ?? ANIMATION_DURATION;
    };

    const hideAlert = (): void => {
        alertSettings.value.isVisible = false;
    };

    return {
        alertSettings,
        hideAlert,
        showAlert,
    };
};
export { useAlertToast };
